<template>
  <div class="post__gallery__area" v-loading="isLoading">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="post_gallery_slider" style="position: relative;">
            <slider v-if="postGallery.length" :settings="BigCardsSettings" ref="BigCards">
              <template v-for="(single, index) in postGallery">
                <big-video-card-with-des :datas="single" :key="index" :canNavigate="isNavigable" />
              </template>
            </slider>
            <!-- 左箭头按钮 -->
            <span
              @click="handlePrevClick"
              class="prev slick-arrow"
            >
              <i class="fal fa-angle-left"></i>
            </span>
            <!-- 右箭头按钮 -->
            <span
              @click="handleNextClick"
              class="next slick-arrow"
            >
              <i class="fal fa-angle-right"></i>
            </span>
          </div>
          <div class="post_gallery_inner_slider" style="position: relative">
            <!-- 注释掉原有的按钮 -->
            <!--
            <span
              @click="postGalleryPrev"
              class="prev slick-arrow"
              style="display: block"><i class="fal fa-angle-left"></i>
            </span>
            <span
              @click="postGalleryNext"
              class="next slick-arrow"
              style="display: block">
              <i class="fal fa-angle-right"></i></span>
            -->
          </div>
        </div>
        <div class="col-lg-4">
          <home-one
            :trendingShortPost="false"
            :signup="false"
            :trendingBigPost="false"
            :ad="false"
            :sharePost="false"
            :darkClass="darkClass"
            role="sidebar"
            :datas="smallPostGallery"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAds } from '@/api/placement';
import config from '@/config';
import Slider from "../Helpers/Slider.vue";
import BigVideoCardWithDes from "../Utility/Cards/BigVideoCardWithDes.vue";
import HomeOne from "../Utility/Sidebar/StyleOne.vue";

export default {
  components: { Slider, BigVideoCardWithDes, HomeOne },
  props: {
    darkClass: {
      type: Object,
      default: () => {}
    }
  },
  inject: ['dataWrapper', 'fetchArticles', 'fetchStatus', 'error'],
  data() {
    return {
      postGallery: [],
      smallPostGallery: [],
      selectedGallery: "trendy",
      miniCardsSettings: {
        slidesToShow: 8,
        slideToScroll: 1,
        autoplay: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              slideToScroll: 1,
              autoplay: true
            }
          }
        ]
      },
      BigCardsSettings: {
        slidesToShow: 1,
        slideToScroll: 1,
        autoplay: true,
        arrows: false
      },
      isNavigable: true,
      isLoading: true,
    };
  },
  created() {
    this.fetchAdsData();
  },
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          this.smallPostGallery = Array.isArray(this.dataWrapper.articles) ? this.dataWrapper.articles : [];
          this.isLoading = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 方法内容保持不变
    handlePrevClick() {
      this.isNavigable = false;
      this.$refs.BigCards.prev();
      setTimeout(() => {
        this.isNavigable = true;
      }, 100);
    },
    handleNextClick() {
      this.isNavigable = false;
      this.$refs.BigCards.next();
      setTimeout(() => {
        this.isNavigable = true;
      }, 100);
    },
    selectGalleryTab(value) {
      this.selectedGallery = value;
    },
    async fetchAdsData() {
      try {
        const adsResponse = await getAds(config.AD_TOPBIGSQUAREROLLINGBANNER);
        this.postGallery = adsResponse.data || [];
        
        this.isLoading = false;
      } catch (error) {
        // 添加错误处理
        console.log('画廊广告加载失败:', error);
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.post_gallery_slider {
  position: relative;
}

.prev.slick-arrow,
.next.slick-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  width: 40px; /* 增大按钮宽度 */
  height: 40px; /* 增大按钮高度 */
  background-color: rgba(0, 0, 0, 0.5); /* 添加背景色，方便查看按钮区域 */
  border-radius: 50%; /* 使按钮呈圆形 */
  text-align: center;
  line-height: 48px; /* 使图标垂直居中 */
  cursor: pointer;
  z-index: 10;
}

.prev.slick-arrow {
  left: 10px;
}

.next.slick-arrow {
  right: 10px;
}

.prev.slick-arrow i,
.next.slick-arrow i {
  font-size: 24px; /* 增大图标字体大小 */
  color: white; /* 设置图标颜色 */
}
</style>